export default __webpack_public_path__ + "static/media/1607.706f2871.png";